import { Injectable } from '@angular/core';
import { Noticia } from '../models/noticia.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NoticiasService {
  constructor(private http: HttpClient) {
   }

  getNoticiasFiscal()
  {
    return this.http.get<Noticia[]>('https://focuscovid.azurewebsites.net/api/Noticias/fiscal');
  }

  getNoticiasTrabalhista()
  {
    return this.http.get<Noticia[]>('https://focuscovid.azurewebsites.net/api/Noticias/trabalhista');
  }

  getNoticiasFinancas()
  {
    return this.http.get<Noticia[]>('https://focuscovid.azurewebsites.net/api/Noticias/financas');
  }

  getNoticiasLegal()
  {
    return this.http.get<Noticia[]>('https://focuscovid.azurewebsites.net/api/Noticias/legal');
  }

  getNoticiasGeral()
  {
    return this.http.get<Noticia[]>('https://focuscovid.azurewebsites.net/api/Noticias/geral');
  }


}
